import { useEffect } from 'react';

type IVoidFunction = () => void;

export const usePageUpdater = (cb: IVoidFunction) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;
    const runner = () => {
      cb();
      timer = setTimeout(runner, 10000);
    };
    runner();
    return () => {
      clearTimeout(timer);
    };
  }, [cb]);
};
